import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ApiDealerService } from '@src/app/core/services/api-dealer.service';
import { PasswordService } from '@src/app/core/services/password.service';
import { MenuItem } from 'primeng/api';
import { SystemDialogService, ToastService } from 'projects/sigv-library/src/public-api';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ErrorDialogMessage } from 'sigv-library/model';
import { BackgroundImageService } from '../../services/background-image.service';

@Component({
  selector: 'app-forget-password-otp',
  templateUrl: './forget-password-otp.component.html',
  styleUrls: ['./forget-password-otp.component.scss']
})
export class ForgetPasswordOtpComponent implements OnInit {

  blobUrlLogin = '';
  blobUrlBg = '';
  items: MenuItem[];
  currentStepIndex = 0;
  account = '';
  otpType = '';
  otpShowEmail = false;
  otpShowPhone = false;
  otp = '';

  private readonly destroy$ = new Subject();
  private resizeSubscription: Subscription;
  
  constructor(
    private backgroundImageService: BackgroundImageService,
    private route: ActivatedRoute,
    private dealerService: ApiDealerService,
    private passwordService: PasswordService,
    private toastService: ToastService,
    private translateService: TranslateService,
    private systemDialogService: SystemDialogService,
    private router: Router,
  ) { 
    this.resizeSubscription = this.backgroundImageService.resize$.subscribe(() => {
      this.blobUrlBg = this.backgroundImageService.blobUrlBg;
      this.blobUrlLogin = this.backgroundImageService.blobUrlLogin;
    });
    this.items = [];
  }

  ngOnInit(): void {
    this.items = [
      {
        label: 'OTP shipping type',
      },
      {
        label: 'OTP Enter',
      },
    ];

    this.getDealerInfo();
  }

  async getDealerInfo(): Promise<void>{
    this.route.queryParams.subscribe((params) => {
      const { account } = params;
      this.account = account;
    });

    var res = await this.dealerService.checkDealer(this.account).toPromise();
    if (res && res.data) {
      this.otpShowEmail = res.data.hasEmail;
      this.otpShowPhone = res.data.hasPhone;
    }

  }

  goNextStep(): void {
    if(this.currentStepIndex == 0 && this.otpType.length > 0){
      this.passwordService
        .forgetPassword(this.account, this.otpType)
        .pipe(takeUntil(this.destroy$))
        .subscribe(({ status, msg, isSMS }) => {
          if (status) {
            if (isSMS == null) {
              this.toastService.success(
                this.translateService.instant('ForgotPassword.AllBeenSent')
              );
            } else {
              isSMS
                ? this.toastService.success(
                  this.translateService.instant(
                    'ForgotPassword.PhoneMailHadBeenSent'
                  )
                )
                : this.toastService.success(
                  this.translateService.instant(
                    'ForgotPassword.MailHadBeenSent'
                  )
                );
            }
          } else {
            this.systemDialogService.showErrorDialog(
              [
                {
                  description: msg ?? '',
                },
              ],
              'Error'
            );
          }
        });
    }
    else if(this.otpType.trim().length == 0){

      var errorMsg: ErrorDialogMessage[] = [];
      const required = this.translateService.instant(
        'Common.Validate.MustNotBeBlank'
      );

      errorMsg.push({ description: 'OTPType', errorMessage: required })

      this.systemDialogService.showErrorDialog(errorMsg);
      return;
    }



    if (this.currentStepIndex < 2) {
      this.currentStepIndex++;
    }

  }

  goBackStep(): void {
    if (this.currentStepIndex > 0) {
      this.currentStepIndex--;
    }
  }



  async checkOTP(): Promise<void>{
    if(this.otp.trim().length == 0){

      var errorMsg: ErrorDialogMessage[]=[];
      const required = this.translateService.instant(
        'Common.Validate.MustNotBeBlank'
      );

      errorMsg.push({ description: 'OTP', errorMessage: required })

      this.systemDialogService.showErrorDialog(errorMsg);
      return;
    }



    var res = await this.passwordService.checkOTP(this.account, this.otp).toPromise();
    if(res.status){
      this.router.navigateByUrl(`/forgotPassword?account=${res.dealerCode}&s=${res.token}`);
    }
    else{
      this.systemDialogService.showErrorDialog(
        [
          {
            description: res.msg ?? '',
          },
        ],
        'Error'
      );
    }

  }

}
